import { useCallback, useState } from "react";
import GuidedTour from "../UI/GuidedTour";
import classes from "../UI/GuidedTour.module.css";

const steps = [
  {
    target: "metronome-tempo",
    title: "Set your tempo",
    text: "Click the BPM display to enter your starting tempo, or use the −1, +1, −5 and +5 buttons to make adjustments. You can change the tempo without stopping the metronome.",
  },
  {
    target: "metronome-tap",
    title: "Find your tempo by tapping",
    text: "Tap twice in rhythm to set the tempo. Continue tapping to refine the BPM. Tap Tempo also works while the metronome is running, so you can adjust your speed without stopping.",
  },
  {
    target: "metronome-ramping",
    title: "Build speed without interrupting your practice",
    text: "Enable ramping and the metronome will gradually increase its tempo in tiny increments as you play. Start at a comfortable speed and concentrate on your technique while the tempo rises almost imperceptibly.",
  },
  {
    target: "metronome-timer",
    title: "Track your practice time",
    text: "The timer records how long the metronome has been running. It pauses when you stop and resumes when you start again. Use Reset to begin a new timing period without affecting playback.",
  },
].map(step => ({ ...step, unavailableText: "This control is currently unavailable. You can continue or exit the tour; your practice settings have not been changed." }));

// Tour navigation stays local; it never calls a metronome control or dispatches settings.
export default function MetronomeQuickTour() {
  const [active, setActive] = useState(false);
  const close = useCallback(() => setActive(false), []);
  return <>
    <button type="button" className={classes.start} onClick={() => setActive(true)}>
      Take a quick tour
    </button>
    {active && <GuidedTour steps={steps} onClose={close} />}
  </>;
}
